import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/service_provider_transaction_records',
  component: Management,
  redirect: '/service_provider_transaction_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/service_provider_transaction_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listServiceProviderTransactionRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/service_provider_transaction_records/ListTable'),
          meta: {
            auth: Auth.listServiceProviderTransactionRecords,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/service_provider_transaction_records/New'),
      meta: {
        auth: Auth.createServiceProviderTransactionRecord
      }
    }
  ]
}
